// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".forgot-password-form-container{margin:10px}", "",{"version":3,"sources":["webpack://src/views/forgot-password/forgot-password.scss"],"names":[],"mappings":"AAAA,gCACE,WAAA","sourcesContent":[".forgot-password-form-container {\n  margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
